__turbopack_context__.v({
  "footer": "Footer-module__q-8iza__footer",
  "footerContent": "Footer-module__q-8iza__footerContent",
  "footerLinks": "Footer-module__q-8iza__footerLinks",
  "footerLogos": "Footer-module__q-8iza__footerLogos",
  "footerSocial": "Footer-module__q-8iza__footerSocial",
});
